import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Symbol } from "../GameComponents/Symbol";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";

@engineComponent(ComponentTypes.DisplayObject)
export class SymbolExtended extends Symbol {
    static CaseTeasingBlur: string = "TEASING_BLUR";
    static CaseTeasingRotation: string = "TEASING_ROTATION";
    static CaseTeasingNowin: string = "TEASING_NOWIN";
    static CaseTeasingNormal: string = "TEASING_NORMAL";
    static CasePulse: string = "PULSE";
    static CaseImpactTeaseShine: string = "IMPACT_TEASE_SHINE";

    static CaseWinDelay: string = "WIN_DELAY";

    create(node: Element): void {
        super.create(node);
    }

    clone(): Symbol {
        let element: SymbolExtended = new SymbolExtended();

        element.elements = this.elements.clone();
        element.addChild(element.elements);

        element.style = this.style;
        element.offsetX = this.offsetX;
        element.offsetY = this.offsetY;
        element.symbolWidth = this.symbolWidth;
        element.symbolHeight = this.symbolHeight;
        element.visible = this.visible;
        element.case = this.case;
        element.style = this.style;
        element.zIndex = this.zIndex;
        element.type = this.type;
        element.hasWinFrame = this.hasWinFrame;

        element.markAsCloned(); // must be called last before return!
        return element;
    }

    getChild(el: string): BaseElement {
        if (this.elements.childs.hasOwnProperty(el)) {
            return this.elements.childs[el];
        }

        return null;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/SymbolExtended.ts
 **/